import React, { useEffect, useState } from "react";
import axios from "axios";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import loadingIcon from '../../../assets/img/loadingElement.gif';
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getLoginInfo } from '../../../shared/utils/storage';
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import Lindo from '../../../app/guards/RouteGuard';
import SharedTable from "../../administration/users/SearchUser";
import { enquiryFormValidation } from '../../../shared/validators/FormValidator';
import { createNotification } from '../../../shared/components/Popup';
function Enquiry() {
  const pageName = "enquiry";
  const navigate = useNavigate();
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const { mgambo } = Lindo();
  const [isSearching, setIsSearching] = useState(false);
  const [application, setApplication] = useState([]);
  const [searchapp, setSearchapp] = useState({
    ApplicationId: "",
    UserName: getLoginInfo()?.user?.Username,
    Station: getLoginInfo()?.user?.StationID,
    FirstName: "",
    Surname: "",
    ReportType: "",
    Surname: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    mgambo("Maulizo");
  }, []);
  const handleOption = (e) => {
    const newValue = e.target.value;

    setSearchapp((prev) => ({
      ...prev,
      ReportType: newValue,
    }));
  };

  /*--------------View Online Portal-----------------*/
  const searchappJasper = async () => {
    setSearchapp((prev) => ({
      ...prev,
      ReportType: searchapp.ReportType === "" ? null : searchapp.ReportType,
      FirstName: searchapp.FirstName === "" ? null : searchapp.FirstName,
      Surname: searchapp.Surname === "" ? null : searchapp.Surname,
      ApplicationId:
        searchapp.ApplicationId === "" ? null : searchapp.ApplicationId,
    }));
    const newErrors = enquiryFormValidation(searchapp);
    try {
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setIsSearching(true);
        setErrors({});

        const result = await handleApplicationManagement(searchapp, "reports");
        setIsSearching(false);
        if (result?.code == 1) {
          setApplication(result?.data);
        } else {
          const info = { type: "info", message: result?.message };
          createNotification(info)();
        }
      }
    } catch (e) {
      setIsSearching(false);
    }
  };

  const clearForm = () => {
    setSearchapp((prev) => ({
      ...prev,
      ReportType: "", // ✅ fixed
      FirstName: "",
      Surname: "",
      ApplicationId: "",
    }));
  };

  /*----------------Styles-------------------*/
  const styles = {
    td1: {
      paddingTop: "5px",
      paddingBottom: "5px",
      textAlign: "center",
      fontSize: "15px",
      fontWeight: "bold",
      width: "200px",
    },
    td2: {
      paddingTop: "5px",
      paddingBottom: "5px",
      textAlign: "center",
      color: "#850505",
      fontSize: "15px",
      width: "300px",
    },
    td3: {
      paddingTop: "3px",
      paddingBottom: "3px",
      textAlign: "right",
      fontWeight: "bold",
      fontSize: "14px",
      width: "200px",
    },
    td4: {
      paddingTop: "3px",
      paddingBottom: "3px",
      textAlign: "left",
      color: "#850505",
      fontSize: "15px",
      width: "300px",
    },
    td5: {
      paddingTop: "3px",
      paddingBottom: "3px",
      width: "20%",
      textAlign: "center",
      color: "#850505",
    },
    th1: {
      width: "20%",
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "14px",
    },
  };

  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body"></div>

              <div className="card2">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="container">
                        <div className="row header" style={{ color: "green" }}>
                          <h4>
                            <b>Application Enquiry</b>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* {MyOption != "" ? ( */}
                <>
                  {/* {MyOption == 1 ? ( */}
                  <>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <div>
                              <Box component="form">
                                <FormControl fullWidth>
                                  <InputLabel id="demo-simple-select-label">
                                    ETD Search
                                  </InputLabel>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="ETD Search"
                                    value={searchapp.ReportType}
                                    onChange={handleOption}
                                  >
                                    <MenuItem value="Portal">Portal</MenuItem>
                                    <MenuItem value="Management">
                                      Management
                                    </MenuItem>
                                    {/* <MenuItem value="3">
                                    ETD Application History
                                  </MenuItem> */}
                                  </Select>
                                </FormControl>
                              </Box>
                            </div>
                          </Box>
                        </div>
                        <div className="col-md-3">
                          {" "}
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <FormControl fullWidth>
                              <TextField
                                id="outlined-required"
                                label="First Name"
                                value={searchapp.FirstName}
                                onChange={(e) =>
                                  setSearchapp({
                                    ...searchapp,
                                    FirstName: e.target.value,
                                  })
                                }
                              />
                            </FormControl>
                          </Box>
                        </div>
                        <div className="col-md-3">
                          {" "}
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <FormControl fullWidth>
                              <TextField
                                id="outlined-required"
                                label="Last Name"
                                value={searchapp.Surname}
                                onChange={(e) =>
                                  setSearchapp({
                                    ...searchapp,
                                    Surname: e.target.value,
                                  })
                                }
                                // onChange={(e) => {
                                //   // setLastName(e.target.value);
                                //   searchapp.Surname =
                                //     e.target.value;
                                // }}
                              />
                            </FormControl>
                          </Box>
                        </div>
                        <div className="col-md-3">
                          <Box component="form" sx={{ minWidth: 230 }}>
                            <FormControl fullWidth>
                              <TextField
                                id="outlined-required"
                                label="Application ID"
                                value={searchapp.ApplicationId}
                                onChange={(e) =>
                                  setSearchapp({
                                    ...searchapp,
                                    ApplicationId: e.target.value,
                                  })
                                }
                              />
                            </FormControl>
                          </Box>
                        </div>
                        <div className="col-md-4"></div>
                        <div className="col-md-6">
                          {" "}
                          <Button
                            variant="contained"
                            className="btn btn-primary"
                            onClick={searchappJasper}
                          >
                            Search
                          </Button>
                          <Button
                            variant="contained"
                            className="btn-danger"
                            onClick={() => clearForm()}
                          >
                            Clear
                          </Button>
                        </div>
                      </div>
                      {errors && (
                        <div className="error-text">
                          {Object.values(errors).map((error, index) => (
                            <p className="error-text" key={index}>
                              {error}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                  {/* ) : null} */}
                </>
                {/* ) : null} */}
                {/* </div> */}
              </div>
              {/* </div> */}

              <div className="card2">
                <div className="card-body">
                  <div className="row">
                    <div className="container">
                      <>
                        <div className="row">
                          <div className="container">
                            <div className="col-md-12"></div>
                            {isLoading ? (
                              <div style={styles.loadingContainer}>
                                <img
                                  src={loadingIcon}
                                  alt="Loading..."
                                  style={styles.loadingImage}
                                />
                              </div>
                            ) : (
                              <>
                                {application?.length > 0 && (
                                  <SharedTable
                                    userData={application}
                                    pageName={pageName}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              </div>
              {/*--------------------------Display----------------- */}
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Enquiry;
